import React, { Fragment } from 'react';

import useGenderCompetitionCategoryForm from './UseGenderCompetitionCategoryForm';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import CompetitionCategoryRadiobuttonList from '@usas/ui-web/components/radiobuttonlists/competitionCategoryRadiobuttonList/CompetitionCategoryRadiobuttonList';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GenderCompetitionCategoryForm = ({
	personState,
	formState,
	errorState,
	setFormData,
	handleSubmit,
	onFormValueChanged,
	isCompetitionCategoryLocked
}) => {
	const {
		competitionGenderState
	} = useGenderCompetitionCategoryForm(personState, formState, setFormData);

	return (
		<Fragment>
			<form onSubmit={handleSubmit}>
				<div className="col-xs-12 col-sm-6 usas-extra-bottom-margin">
					<span className={isCompetitionCategoryLocked === false ? global.DisplayComponent : global.HideComponent}>
						<CompetitionCategoryRadiobuttonList
							label={<Headings.H6>Select Competition Category</Headings.H6>}
							isVertical={true}
							name="competitionGenderTypeId"
							value={Number(formState.competitionGenderTypeId)}
							error={errorState.competitionGenderTypeId}
							message={errorState.competitionGenderTypeId}
							onChange={(value) => { onFormValueChanged('competitionGenderTypeId', Number(value)) }} />
					</span>
					<span className={isCompetitionCategoryLocked === true ? global.DisplayComponent : global.HideComponent}>
						<ReadOnly
							label="Competition Category"
							value={formState.competitionGenderTypeDisplayName}
							name='competitionGenderTypeDisplayName' />
					</span>
				</div>
			</form>
			<PopUpModal
				widthPct={50}
				maxWidth={250}
				title={Constants.LOADING_MSG}
				displayPopUp={competitionGenderState?.isArrayLoading} />
		</Fragment>);
}

export default GenderCompetitionCategoryForm;